// frontend/src/components/CompletenessIndicator/CompletenessIndicator.js
// Purpose: Display a visual indicator of part data completeness
// Desired outcome: Provide clear feedback about how complete a part's data is

import React from 'react';
import './CompletenessIndicator.css';

const CompletenessIndicator = ({ score }) => {
  // Determine color class based on score
  const getColorClass = () => {
    if (score >= 80) return 'high';
    if (score >= 50) return 'medium';
    return 'low';
  };

  return (
    <div className="completeness-indicator">
      <div className="completeness-label">
        <span>Completeness</span>
        <span className="completeness-value">{score}%</span>
      </div>
      <div className="completeness-bar">
        <div 
          className={`completeness-fill ${getColorClass()}`}
          style={{ width: `${score}%` }}
        ></div>
      </div>
    </div>
  );
};

export default CompletenessIndicator;